import {NgModule} from '@angular/core';
import {BreadcrumbsComponent} from '../components/breadcrumbs.component';
import {RouterModule} from '@angular/router';
import {CommonModule} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {MatLegacyTooltipModule as MatTooltipModule} from '@angular/material/legacy-tooltip';

@NgModule({
    declarations: [BreadcrumbsComponent],
    imports: [
        CommonModule,
        RouterModule,
        MatIconModule,
        MatTooltipModule,
    ],
    exports: [BreadcrumbsComponent]
})
export class BreadcrumbsModule {
}
